import React, { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Pill } from 'ui-components/components/pill';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Checkbox } from 'ui-components/components/checkbox';
import { noop } from 'ui-components/default-props/noop';
import Global from '../../../../store/global-selectors';

import { ProductDetailsContext } from '../../context';

import style from './style.module.css';

const getDisplayContent = (orderTagIds, tags) => {
  if (orderTagIds.length === 0) {
    return <div />;
  }

  if (orderTagIds.length === 1) {
    const [tagId] = orderTagIds;
    if (tagId === null) {
      return <div />;
    }
    const tag = tags.find((t) => t.tagId === tagId);
    return (
      <div className={style['single-pill-wrapper']}>
        <Pill className={style['tag-pill']} color={tag.hexColor} />
        <div>{tag.name}</div>
      </div>
    );
  }
  return (
    <div>
      {orderTagIds.map((tagId, index) => {
        const tag = tags.find((t) => t.tagId === tagId);
        return tag && <Pill key={index} className={style['tag-pill']} color={tag.hexColor} />;
      })}
    </div>
  );
};

export const OrderTagsDropdown = () => {
  const { orderTagIds = [], setOrderTagIds, userHasPermission } = useContext(ProductDetailsContext);
  const orderTags = useSelector(Global.selectSellerTags) || [];

  const onTagToggled = useCallback(
    (tagId) => {
      const tagIdIndex = orderTagIds.indexOf(tagId);
      const newTags = orderTagIds.includes(tagId)
        ? [...orderTagIds.slice(0, tagIdIndex), ...orderTagIds.slice(tagIdIndex + 1)]
        : [...orderTagIds, tagId];
      setOrderTagIds(newTags);
    },
    [setOrderTagIds, orderTagIds],
  );

  const isTagSelected = useCallback((orderTag) => orderTagIds.includes(orderTag.tagId), [orderTagIds]);

  return (
    <DropdownMenu className={style['order-tag-dropdown']} disabled={!userHasPermission} dropDownMenuShouldHaveWidthOfButton>
      <DropdownMenuToggler className={style['order-tag-dropdown-toggler']} theme='white-outlined'>
        {getDisplayContent(orderTagIds, orderTags)}
      </DropdownMenuToggler>
      {orderTags.map((orderTag) => (
        <DropdownMenuItem key={orderTag.tagId} className={style['checklist-row']} onClick={() => onTagToggled(orderTag.tagId)}>
          <Checkbox checked={isTagSelected(orderTag)} onChange={noop} />
          <Pill className={style.pill} color={orderTag.hexColor} label={orderTag.name} theme='no-status' truncate />
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
